import { AlertState, AlertType } from "@lib/stores/common/types";
import { Alert, AlertDescription } from "@ui/alert";
import { AlertCircle } from "lucide-react";

const CommonAlert = ({ alert }: { alert: AlertState }) => {
  const colorStyle = () => {
    switch (alert.type) {
      case AlertType.SUCCESS:
        return "bg-green-500";
      case AlertType.WARNING:
        return "bg-yellow-500";
      default:
        return "bg-red-500";
    }
  };

  return (
    <Alert
      variant="destructive"
      className={`fixed left-1/2 top-2 z-[999] mx-auto w-fit -translate-x-1/2 ${colorStyle()} p-3 [&>svg]:top-3`}
    >
      <AlertCircle className="my-auto h-5 w-5 text-white" />
      {alert?.messages && (
        <AlertDescription className="me-5 text-[14px] text-white">
          {alert?.messages?.[0].message}
        </AlertDescription>
      )}
    </Alert>
  );
};

export default CommonAlert;
